export const mediaqueries = {
    'max-width-700': '@media (max-heiht: 700px)',
    'max-width-1600': '@media (max-width: 1600px)',
    'max-width-1440': '@media (max-width: 1440px)',
    'max-width-1000': '@media (max-width: 1000px)',
    'max-height-780': '@media (max-height: 780px)',
    'max-height-600': '@media (max-height: 600px)',
    'max-height-550': '@media (max-height: 550px)'
  } 